import { RootState } from 'common/redux/core/root.reducer';

export const getMessageModalDetails = (state: RootState) => state.appState.messageModal;

export const getShowLoader = (state: RootState) => state.appState.showLoader;

export const getSessionRenewalVisibility = (state: RootState) =>
    state.appState.isSessionRenewalVisible;
